import { createContext } from 'react';

export const ComplianceMessagingContext = createContext({
  complianceList: [],
  nextCompliance: null,
  error: null,
  isLoading: false,
});
